import React, { useState } from 'react'

const Contact = () => {
 const [formData, setFormData] = useState({
 name: '',
 email: '',
 message: ''
 })

 const handleSubmit = (e) => {
 e.preventDefault()
 alert('感谢您的留言！我们会尽快与您联系。')
 setFormData({ name: '', email: '', message: '' })
 }

 const handleChange = (e) => {
 setFormData({
 ...formData,
 [e.target.name]: e.target.value })
 }

 return (
 <section id="contact" className="section">
 <div className="container">
 <h2 className="section-title">联系我们</h2>
 <p className="section-subtitle">
有任何问题或定制需求，欢迎随时与我们联系 </p>
 <div style={{
 display: 'grid',
 gridTemplateColumns: '1fr 1fr',
 gap: '60px'
 }}>
 <div>
 <div style={{
 background: 'var(--white)',
 padding: '40px',
 borderRadius: '20px',
 boxShadow: 'var(--shadow)'
 }}>
 <h3 style={{
 fontSize: '1.5rem',
 fontWeight: '600',
 marginBottom: '24px',
 color: 'var(--text-dark)'
 }}>
店铺信息 </h3>
 <div style={{ marginBottom: '24px' }}>
 <h4 style={{
 fontSize: '1rem',
 fontWeight: '600',
 marginBottom: '8px',
 color: 'var(--text-dark)'
 }}>
地址 </h4>
 <p style={{ color: 'var(--text-light)' }}>
上海市黄浦区南京东路123号甜蜜时光蛋糕店 </p>
 </div>
 <div style={{ marginBottom: '24px' }}>
 <h4 style={{
 fontSize: '1rem',
 fontWeight: '600',
 marginBottom: '8px',
 color: 'var(--text-dark)'
 }}>
营业时间 </h4>
 <p style={{ color: 'var(--text-light)' }}>
周一至周日：9:00 -21:00 </p>
 </div>
 <div style={{ marginBottom: '24px' }}>
 <h4 style={{
 fontSize: '1rem',
 fontWeight: '600',
 marginBottom: '8px',
 color: 'var(--text-dark)'
 }}>
联系电话 </h4>
 <p style={{ color: 'var(--text-light)' }}>
400-123-4567 </p>
 </div>
 <div>
 <h4 style={{
 fontSize: '1rem',
 fontWeight: '600',
 marginBottom: '8px',
 color: 'var(--text-dark)'
 }}>
邮箱 </h4>
 <p style={{ color: 'var(--text-light)' }}>
 hello@sweettime.com </p>
 </div>
 </div>
 </div>
 <div>
 <div style={{
 background: 'var(--white)',
 padding: '40px',
 borderRadius: '20px',
 boxShadow: 'var(--shadow)'
 }}>
 <h3 style={{
 fontSize: '1.5rem',
 fontWeight: '600',
 marginBottom: '24px',
 color: 'var(--text-dark)'
 }}>
在线留言 </h3>
 <form onSubmit={handleSubmit}>
 <div style={{ marginBottom: '20px' }}>
 <label style={{
 display: 'block',
 marginBottom: '8px',
 fontWeight: '500',
 color: 'var(--text-dark)'
 }}>
姓名 </label>
 <input type="text"
 name="name"
 value={formData.name}
 onChange={handleChange}
 required style={{
 width: '100%',
 padding: '12px 16px',
 border: '1px solid #e5e7eb',
 borderRadius: '8px',
 fontSize: '16px',
 transition: 'border-color 0.3s ease'
 }}
 />
 </div>
 <div style={{ marginBottom: '20px' }}>
 <label style={{
 display: 'block',
 marginBottom: '8px',
 fontWeight: '500',
 color: 'var(--text-dark)'
 }}>
邮箱 </label>
 <input type="email"
 name="email"
 value={formData.email}
 onChange={handleChange}
 required style={{
 width: '100%',
 padding: '12px 16px',
 border: '1px solid #e5e7eb',
 borderRadius: '8px',
 fontSize: '16px',
 transition: 'border-color 0.3s ease'
 }}
 />
 </div>
 <div style={{ marginBottom: '24px' }}>
 <label style={{
 display: 'block',
 marginBottom: '8px',
 fontWeight: '500',
 color: 'var(--text-dark)'
 }}>
留言 </label>
 <textarea name="message"
 value={formData.message}
 onChange={handleChange}
 required rows="4"
 style={{
 width: '100%',
 padding: '12px 16px',
 border: '1px solid #e5e7eb',
 borderRadius: '8px',
 fontSize: '16px',
 resize: 'vertical',
 transition: 'border-color 0.3s ease'
 }}
 ></textarea>
 </div>
 <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
发送留言 </button>
 </form>
 </div>
 </div>
 </div>
 </div>
 </section>
 )
}

export default Contact